import axiosInstance from 'axios_s';
import * as apiroutes from '../../apiroutes'
import localStorageService from './localStorageService'

class FileServices {
    uploadFiles = async (data) => {
        try {
            const accessToken = await localStorageService.getItem("accessToken");
            const config = {
                method: "post",
                url: apiroutes.UPLOAD_FILES,
                data: data,
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data"
                }
            };
            const response = await axiosInstance(config);
            return response;
        } catch (error) {
            console.log("error", error);
            return error;
        }
    }

    getDocouments = async (params) => {
        try {
            const accessToken = await localStorageService.getItem("accessToken");
            const config = {
                method: "get",
                url: apiroutes.GET_UPLOADED_FILES,
                params: params,
                headers: { Authorization: `Bearer ${accessToken}` }
            };
            const response = await axiosInstance(config);
            return response;
        } catch (error) {
            console.log("error", error);
            return error;
        }
    }
}

export default new FileServices()